import $x from '@/utils/$x';
import moment from 'moment';
import sha1 from 'sha1';

export const appid = 'ww4b23df7ef770fdd2';

export const miniAppid = 'wx2d0a76ddc7eca48c';

import { Button, Modal, Form, message } from 'antd';

const jsApiList = ['getCurExternalContact', 'getContext', 'sendChatMessage'];

/**
 * menu Highlight key
 * @param pathname string
 */
export const queryKeysByPath = (pathname, menusData) => {
  const trimSlash = (s) => (s || '').replace(/^\/+|\/+$/g, '');
  const normalizedPathname = trimSlash(pathname);
  const path = normalizedPathname;
  const routes = path ? path.split('/') : [];
  const openKey = routes[0] || '';
  let selectKey = routes[1] || routes[0] || '';
  let title = '';

  // 标题：取菜单里 link 最长的匹配项
  title = '';

  if (Array.isArray(menusData) && menusData.length > 0) {
    // 策略：用 link 做后缀匹配，收集所有匹配项，优先选择 link 最长的叶子节点
    const matches = [];
    // 标题只认 link 匹配项：key 匹配过宽（如 pathname /user/record 会命中 key 为 user 的菜单），
    // 用于侧边栏高亮无碍，但用作标签标题会误显示无关菜单名
    const linkMatches = [];
    const walk = (list) => {
      for (const item of list || []) {
        if (!item) continue;
        const itemLink = trimSlash(item.link || item.pathname || '');
        const itemKey = trimSlash(item.key || '');

        // 用 link 匹配
        if (itemLink) {
          const isMatch =
            normalizedPathname === itemLink ||
            normalizedPathname.endsWith(itemLink) ||
            itemLink.endsWith(normalizedPathname) ||
            normalizedPathname.startsWith(itemLink);
          if (isMatch) {
            matches.push({ key: item.key, linkLen: itemLink.length, title: item.title });
            linkMatches.push({ key: item.key, linkLen: itemLink.length, title: item.title });
          }
        }

        // 用 key 匹配（pathname 是 key 的前缀，或 key 是 pathname 的前缀）
        if (itemKey) {
          const isKeyMatch =
            normalizedPathname === itemKey ||
            normalizedPathname.startsWith(itemKey) ||
            itemKey.startsWith(normalizedPathname);
          if (isKeyMatch) {
            matches.push({ key: item.key, linkLen: itemKey.length, title: item.title });
          }
        }

        if (Array.isArray(item.children) && item.children.length > 0) {
          walk(item.children);
        }
      }
    };
    walk(menusData);

    if (!title && linkMatches.length > 0) {
      linkMatches.sort((a, b) => b.linkLen - a.linkLen);
      title = linkMatches[0].title || '';
    }

    // 选择 link 最长的匹配项（最精确的匹配）
    if (matches.length > 0) {
      matches.sort((a, b) => b.linkLen - a.linkLen);
      selectKey = matches[0].key;
    }
  }

  return { openKey, selectKey, title };
};

export const dayFormat = (time, format) => {
  if (!time) return '';
  return moment(time).format(format);
};

/**
 * 企业微信网页授权
 */
export const getAuthorize = (redirectUri) => {
  const callbackUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww4b23df7ef770fdd2&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${Math.ceil(
    Math.random() * 1000,
  )}#wechat_redirect`;

  window.location.href = callbackUrl;
};

/************************企业微信授权登录*************************/

export const getWXAuthorize = (redirectUri) => {
  const callbackUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${Math.ceil(
    Math.random() * 1000,
  )}#wechat_redirect`;
  // message.info(callbackUrl);
  window.location.href = callbackUrl;
};

/************************企业微信扫码登录*************************/
/**
 * 构造独立窗口登录二维码
 */
export const qrConnect = (appid, agentId, redirectUri) => {
  return `https://open.work.weixin.qq.com/wwopen/sso/qrConnect?appid=${appid}&agentid=${agentId}&redirect_uri=${redirectUri}&state=STATE`;
};

export const wwLogin = (id, redirectUri) => {
  return new WwLogin({
    id: id,
    appid: appid,
    agentid: UMI_AGENTID,
    redirect_uri: redirectUri,
    state: 'web_login',
    lang: 'zh',
  });
};

export const wxInject = async (callback) => {
  const res = await $x.get('/ticket/get');
  if (res.code === '00000') {
    const nonceStr = Math.random().toString(36).slice(-8);
    const timestamp = new Date().getTime();
    const url = location.href.split('#')[0];
    const signUrl = `jsapi_ticket=${res.data}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`;
    const signature = sha1(signUrl);

    let config = {
      corpid: appid, // 必填，企业微信的corpid，必须与当前登录的企业一致
      agentid: UMI_AGENTID, // 必填，企业微信的应用id （e.g. 1000247）
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
      jsApiList: jsApiList, //必填，传入需要使用的接口名称
    };

    console.log(JSON.stringify(config));

    try {
      wx.agentConfig({
        ...config,
        success: function (res) {
          console.log('success');
          callback();
        },
        fail: function (res) {
          console.log('fail');
          console.log(res);
        },
      });
    } catch (error) {
      return error;
    }

    // wx.ready(() => {
    //   callback();
    // });
  }
};


// 把base64转成Blob对象
export function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  // eslint-disable-next-line no-plusplus
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}


/**
 * 微信发送消息
 * @param {*} params
 */
export const wxSendChatMessage = (params) => {
  wx.invoke(
    'sendChatMessage',
    {
      msgtype: 'miniprogram',
      enterChat: true,
      miniprogram: {
        appid: miniAppid,
        title: params.title, //卡片title
        imgUrl: params.imgUrl, //卡片图片
        page: params.page, //文本跳转url
      },
    },
    function (res) {
      if (res.err_msg == 'sendChatMessage:ok') {
        //发送成功
        console.log('发送成功');
      } else {
        message.error(res.err_msg);
      }
    },
  );
};

// uuid generator
export function guuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function debounce(fn, delayTime = 300) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delayTime);
  };
}

export function getFileSize(fileByte) {
  const fileSizeByte = fileByte;
  let fileSizeMsg = '';
  if (fileSizeByte < 1048576)
    fileSizeMsg = `${(fileSizeByte / 1024).toFixed(2)}KB`;
  else if (fileSizeByte === 1048576) fileSizeMsg = '1MB';
  else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824)
    fileSizeMsg = `${(fileSizeByte / (1024 * 1024)).toFixed(2)}MB`;
  else if (fileSizeByte > 1048576 && fileSizeByte === 1073741824)
    fileSizeMsg = '1GB';
  else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776)
    fileSizeMsg = `${(fileSizeByte / (1024 * 1024 * 1024)).toFixed(2)}GB`;
  else fileSizeMsg = '文件超过1TB';
  return fileSizeMsg;
}

export function getHashKey() {
  let keyString = '';
  const { host } = window.location;
  if (host.indexOf('test') !== -1 || host.indexOf('local') !== -1) {
    keyString = 'eelsliveshow';
  } else {
    keyString = 'lliveshoww';
  }

  return keyString;
}

export function formatTime(seconds) {
  if (!seconds) {
    return '-';
  }
  const hour = parseInt(seconds / 3600, 10);
  const mins = parseInt((seconds - hour * 3600) / 60, 10);
  const sec = parseInt(seconds % 60, 10);
  return `${hour > 9 ? hour : '0' + hour}:${mins > 9 ? mins : '0' + mins}:${
    sec > 9 ? sec : '0' + sec
  }`;
}
/**
 * 合并classname
 * @param  {...any} rest
 * @returns
 */
export function classname(...rest) {
  return rest.join(' ');
}

// 用户数组中对象元素的去重
export function uniqueArray(arr, key = 'id') {
  // 去重
  let cacheObj = {};
  arr.forEach((item) => {
    cacheObj[item[key]] = item;
  });
  // 对象转数组
  return Object.values(cacheObj);
}

///判断H5页面是否在微信/企业微信环境中打开：
export function envJudge() {
  var isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 是否手机端
  var isWx = /micromessenger/i.test(navigator.userAgent); // 是否微信
  var isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信

  if (isComWx && isMobile) { //手机端企业微信
      return 'com-wx-mobile'
  }
  else if (isComWx && !isMobile) { //PC端企业微信
      return 'com-wx-pc'
  }
  else if (isWx && isMobile) { // 手机端微信
      return 'wx-mobile';
  }
  else if (isWx && !isMobile) { // PC端微信
      return 'wx-pc';
  }
  else {
      return 'other';
  }
}
